export default "__VITE_ASSET__Crz8YCnS__"